module.exports = __webpack_public_path__ + "static/media/book-item-delete.5827886a.svg";